document.addEventListener('DOMContentLoaded', function () {
   const divJustifSenderBlock = document.getElementById('justifSenderBlock');
   const divFormInstitution = document.getElementById('user_justification_form_institutionName');
   const inputFormFile = document.getElementById('user_justification_form_file');
   if (divJustifSenderBlock) {
       divJustifSenderBlock.addEventListener('click', function (e) {
           if
           (
               divFormInstitution.value === ''
               || divFormInstitution.value.length < 3
               || divFormInstitution.value.length > 255
           ) {
               e.preventDefault();
               divFormInstitution.focus();
               divFormInstitution.classList.add('is-invalid');
               divFormInstitution.placeholder = 'Veuillez renseigner le nom de votre établissement';
           } else {
               inputFormFile.click();
           }
       });
   }
   if (inputFormFile) {
       inputFormFile.addEventListener('change', function () {
           document.getElementById('user_justification_form_send').click();
       });
   }
});
